import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './styles/globals.css';

// New / rebranded pages
import { IndexPage } from './pages/IndexPage';
import { AboutPage } from './pages/AboutPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { ProgramDetailPage } from './pages/ProgramDetailPage';
import { PricingPage } from './pages/PricingPage';
import { GalleryPage } from './pages/GalleryPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';

// Legacy template pages — kept as hidden "tease" routes (not in nav)
import { StudioPage } from './pages/StudioPage';
import { SchedulePage } from './pages/SchedulePage';
import { ClassesPage } from './pages/ClassesPage';
import { InstructorsPage } from './pages/InstructorsPage';
import { FirstTimersPage } from './pages/FirstTimersPage';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Primary site */}
        <Route path="/" element={<IndexPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/programs/:slug" element={<ProgramDetailPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />

        {/* Legacy tease routes (not linked in navigation) */}
        <Route path="/studio" element={<StudioPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/classes" element={<ClassesPage />} />
        <Route path="/instructors" element={<InstructorsPage />} />
        <Route path="/first-timers" element={<FirstTimersPage />} />
      </Routes>
    </Router>
  );
};

export default App;
